export default "__VITE_PUBLIC_ASSET__fbe19998__"